import { render, staticRenderFns } from "./SafetyResponsiveSidebar.vue?vue&type=template&id=c7fafb9a&scoped=true&"
import script from "./SafetyResponsiveSidebar.vue?vue&type=script&lang=js&"
export * from "./SafetyResponsiveSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fafb9a",
  null
  
)

export default component.exports